export const breakpoint = {
    XSmall: "320px",
    Small: "640px",
    Medium: "768px",
    Large: "1024px",
    XLarge: "1280px",
    XXLarge: "1440px",
    XXXLarge: "1920px",
    MobileMax: "1023px"
};

export const Device = {
    mobileXS: `@media(min-width: ${breakpoint.XSmall})`,
    mobile: `@media(min-width: ${breakpoint.Small})`,
    mobileMax: `@media(max-width: ${breakpoint.MobileMax})`,
    tablet: `@media(min-width: ${breakpoint.Medium})`,
    tabletLandscape: `@media(min-width: ${breakpoint.Large})`,
    laptop: `@media(min-width: ${breakpoint.XLarge})`,
    desktop: `@media(min-width: ${breakpoint.XXLarge})`,
    desktopLG: `@media(min-width: ${breakpoint.XXXLarge})`
};